import { convertCultureToRef } from '@/utils/common-util';
import { useLocale } from 'next-intl';
import { WC_PROMOTION_ACTIVITY_ASSET_LOCALE_LIST } from '../constants';

export const useWcPromotionActivityAssetLocale = () => {
	const locale = useLocale();
	const shortLang = convertCultureToRef(locale ?? 'en-US', true);
	const assetLocale = WC_PROMOTION_ACTIVITY_ASSET_LOCALE_LIST.includes(shortLang) ? (shortLang === 'zhcn' ? 'cs' : shortLang) : 'en';

	return assetLocale;
}